import {Button, styled} from "@mui/material";

export const RecipientEditButton = styled(Button)(() => ({
    padding: '0.5rem',
    minWidth: 'unset'
}));
